import * as React from 'react';
import AddProductDetail from 'pages/product/product-detail-page/add-product';
import ProductItem from 'pages/product/product-detail-page/product-item';
import ProductPrice from 'pages/product/product-detail-page/product-price';
import {
    useCurrencyListQuery,
    useProductCategoryListQuery,
} from 'store/slices/product/product-enum';
import {
    useAddProductMutation,
    useLazyGetProductQuery,
} from 'store/slices/product/product-list';
import { useEffect } from 'react';
import { openSnackbar } from 'store/slices/snackbar/snackbar-slice';
import { useAppDispatch } from 'hooks/redux';
import { useParams } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import SuccessSnackbarEffect from 'component/success-snackbar';

interface Props {
    viewProduct: string;
}
const ProductDetail: React.FC<Props> = ({ viewProduct }) => {
    const { data: productCategoryList } = useProductCategoryListQuery();
    const { data: getCurrencyList } = useCurrencyListQuery();
    const [creatProduct, { data, error, isError, isSuccess }] =
        useAddProductMutation();

    const [getProduct, { data: productData }] = useLazyGetProductQuery();

    const { productId } = useParams<{ productId: string }>();

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (productId || viewProduct) {
            getProduct(viewProduct ?? productId);
        }
    }, [productId, viewProduct]);

    useEffect(() => {
        if (error && 'data' in error) {
            dispatch(
                openSnackbar({
                    message: error?.data.message,
                    severity: 'error',
                    open: true,
                    position: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                }),
            );
        }
    }, [isError]);

    return (
        <>
            <Grid container spacing={2} p={pxToRem(10)}>
                <Grid size={12}>
                    <AddProductDetail
                        viewProduct={viewProduct}
                        getProductId={getProduct}
                        creatProduct={creatProduct}
                        productCategoryList={productCategoryList}
                        productData={productData}
                        productId={productId}
                    />
                </Grid>

                <Box
                    sx={{
                        width: '100%',
                        pointerEvents:
                            data?.productId || productId ? 'auto' : 'none',
                        opacity: data?.productId || productId ? 1 : 0.4,
                    }}
                >
                    {(viewProduct || data?.productId || productId) && (
                        <>
                            <Grid size={12}>
                                <ProductItem
                                    productId={productId}
                                    dataProductId={data?.productId}
                                    viewProduct={viewProduct}
                                />
                            </Grid>
                            <Grid size={12}>
                                <ProductPrice
                                    currencyList={getCurrencyList}
                                    productData={productData}
                                    productId={productId}
                                    dataProductId={data?.productId}
                                />
                            </Grid>
                        </>
                    )}
                </Box>
            </Grid>

            <SuccessSnackbarEffect
                isSuccess={isSuccess}
                message={'Successfully Created an Product!'}
            />
        </>
    );
};
export default ProductDetail;
